(() => {
  document.addEventListener('click', (event) => {
    const filter = event.target.closest('[data-bmf-filter]');
    if (filter) {
      const gallery = filter.closest('[data-bmf-gallery]');
      gallery.querySelectorAll('[data-bmf-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
      gallery.querySelectorAll('[data-bmf-mode]').forEach(card => {
        card.hidden = filter.dataset.bmfFilter !== 'all' && card.dataset.bmfMode !== filter.dataset.bmfFilter;
        if (card.hidden) card.querySelector('video')?.pause();
      });
    }
    const speed = event.target.closest('[data-bmf-speed]');
    if (speed) {
      const video = speed.closest('.bmf-exercise').querySelector('video');
      if (!video) return;
      const slow = speed.getAttribute('aria-pressed') !== 'true';
      video.playbackRate = slow ? 0.5 : 1;
      speed.setAttribute('aria-pressed', String(slow));
    }
  });
  document.addEventListener('play', (event) => {
    if (!(event.target instanceof HTMLVideoElement) || !event.target.closest('[data-bmf-gallery]')) return;
    document.querySelectorAll('[data-bmf-gallery] video').forEach(video => { if (video !== event.target) video.pause(); });
  }, true);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll('[data-bmf-gallery] video').forEach(video => video.pause());
  });
})();